{
  "error.cookie_needed.description": "Your browser is set to block cookies and local storage.\nPlease allow cookies in your browser preferences to access Experience Cloud.",
  "error.cookie_needed.heading": "Cookies are blocked",
  "error.cookie_needed.refreshBtn": "Refresh",
  "error.not_found.description": "This page isn't available. Try checking the URL or visit a different page.",
  "error.not_found.heading": "Error 404: Page not found",
  "error.offline.description": "Check your internet connection and refresh the page",
  "error.offline.heading": "No internet connection",
  "error.rate_limit.description": "We're experiencing high volumes. Please reload the page or try again in a few minutes.\nIf you continue to get this message, contact customer care and reference:\nEIM Instance Id {instanceId}",
  "error.rate_limit.heading": "Error 429: Rate limited",
  "error.rate_limit.refreshBtn": "Refresh",
  "error.timeout.description": "This page was not able to load. Try refreshing or visit a different page.\nIf you continue to get this message, contact customer care and reference:\nEIM Instance Id {instanceId}",
  "error.timeout.heading": "Error 408: Request timeout",
  "error.timeout.refreshBtn": "Refresh",
  "error.unknown.description": "The page isn't loading correctly. Please check your login and try again.\nIf you continue to get this message, contact customer care and reference:\nEIM Instance Id {instanceId}",
  "error.unknown.heading": "Failed to load page",
  "error.unknown.refreshBtn": "Refresh"
} 
